var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
    intersection: {
      threshold: 0.75,
    },
    callback: _vm.visibilityChanged,
    throttle: 750,
  }),expression:"{\n    intersection: {\n      threshold: 0.75,\n    },\n    callback: visibilityChanged,\n    throttle: 750,\n  }"}],staticClass:"w-full overflow-hidden",class:_vm.classes,staticStyle:{"background-size":"cover","min-height":"120px"},style:({ backgroundImage: _vm.visibleSource})})
}
var staticRenderFns = []

export { render, staticRenderFns }